export enum ExportType {
    PDF = "PDF",
    DOCX = "DOCX"
    //HTML
}